import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';
import Layout from 'common/components/layout';
import PostList from 'modules/help/components/FaqList';
import Breadcrumbs from 'common/components/cards/Breadcrumbs-Card';
import useHttp from 'common/hooks/useHttp';
import { useHelpContext } from 'common/context/help-context';

const Qustion = () => {
  const { query } = useRouter();
  const { loading, sendRequest } = useHttp();
  const HelpCtx = useHelpContext();
  const [hasLayout, setHasLayout] = useState<boolean>(true);

  useEffect(() => {
    if (query.header === '0') setHasLayout(false);
  }, [query.header]);

  useEffect(() => {
    if (query.id) fetch();
  }, [query.id]);

  const fetch = async () => {
    HelpCtx?.setLoading(true);
    sendRequest(
      {
        url: `/posts?categoryType=faq&categoryId=${query.id}`,
      },
      onSuccess
    );
  };

  const onSuccess = (res: Responsive) => {
    HelpCtx?.setLoading(false);
    HelpCtx?.handleFaqs(res.data.items);
    HelpCtx?.handleCategory(res.data.items[0]?.category?.title);
  };

  useEffect(() => {
    if (!HelpCtx?.categories) fetchCategories();
  }, [HelpCtx]);

  const fetchCategories = async () => {
    sendRequest({ url: `/categories?type=faq` }, onSuccessFetchCategories);
  };

  const onSuccessFetchCategories = (res: Responsive) => {
    HelpCtx?.handleCategories(res.data.items);
  };

  return (
    <>
      <Head>
        <title>{HelpCtx?.category || 'Category Title'}- Apollon</title>
      </Head>
      <Layout showFooter={hasLayout} showHeader={hasLayout}>
        <Breadcrumbs
          searchUrl='/posts?categoryType=faq&searchKey='
          searchLink='/help'
          links={[
            {
              title: 'Help Centre',
              href: '/help/categories',
            },
            {
              title: HelpCtx?.category || 'Title Help Centre',
            },
          ]}
          placeholder='Write a question or a problem'
        />
        <PostList />
      </Layout>
    </>
  );
};

export default Qustion;
